import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import MenuItem from "./EditItem/MenuItem";
import Modifiers from "./EditItem/Modifiers";

const EditItem = (params) => {
  const history = useHistory();
  const { id } = useParams();
  const [tab, setTab] = useState("modifiers"); //menu_item
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="container px-0">
          <div className="row mt-2">
            <div className="tab-section">
              <div className="nav nav-tabs" id="nav-tab">
                <button
                  className={`nav-link${tab == "menu_item" ? " active" : ""}`}
                  id="nav-home-tab"
                  type="button"
                  onClick={() => setTab("menu_item")}
                >
                  MENU ITEM
                </button>
                <button
                  className={`nav-link${tab == "modifiers" ? " active" : ""}`}
                  id="nav-profile-tab"
                  type="button"
                  onClick={() => setTab("modifiers")}
                >
                  MODIFIERS
                </button>
                <button
                  className={`nav-link${tab == "content" ? " active" : ""}`}
                  id="nav-contact-tab"
                  type="button"
                  onClick={() => setTab("content")}
                >
                  CONTENT
                </button>

                <button
                  className={`nav-link${tab == "master" ? " active" : ""}`}
                  id="nav-mastersetting-tab"
                  type="button"
                  onClick={() => setTab("master")}
                >
                  Master Settings
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="tab-content" id="nav-tabContent">
          {tab == "menu_item" && <MenuItem id={id} />}
          {tab == "modifiers" && <Modifiers id={id} />}
        </div>
      </div>
    </UserInterface>
  );
};
export default EditItem;
